import React from "react";

import * as AntIcon from "@ant-design/icons";
import { Tooltip } from "antd";

import SSOIcon from "../../../assets/icons/SSOIcon";
import Can from "../../../components/Can";
import designSystemColors from "../../../styles";
import useCheckPermission from "../../../utils/useCheckPermission";
import * as S from "../style";

function ActionsSection({
  row,
  onUpdateUser,
  onRestoreUser,
  onDeleteUser,
  handleSSO,
  isSSOActive,
  isDomainActive,
}) {
  const hasPermissionToViewUserSSO = useCheckPermission(
    "view_user_sso_permission"
  );

  return (
    <S.ActionsSection>
      <div onClick={() => onUpdateUser(row, true)}>
        <AntIcon.EyeOutlined
          className="action-icon"
          style={{
            fontSize: "19px",
          }}
        />
      </div>
      {isDomainActive && hasPermissionToViewUserSSO && (
        <div onClick={() => handleSSO(row)}>
          <Tooltip
            title={
              isSSOActive
                ? "SSO Ativo. Deseja Inativa-lo?"
                : "SSO Inativo. Deseja Ativá-lo?"
            }
            style={{
              fontWeight: "bold",
            }}
          >
            <span>
              <SSOIcon
                color={
                  isSSOActive
                    ? designSystemColors.activateGreen
                    : designSystemColors.errorColor
                }
                alt="Icone menu"
                className="sso-icon"
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              />
            </span>
          </Tooltip>
        </div>
      )}
      <div onClick={() => onUpdateUser(row)}>
        <AntIcon.EditOutlined className="action-icon" />
      </div>
      <div
        onClick={() =>
          row.deleted_at ? onRestoreUser(row) : onDeleteUser(row)
        }
      >
        {row.deleted_at ? (
          <Can permission="reactivate_users">
            <AntIcon.ReloadOutlined className="action-icon" />
          </Can>
        ) : (
          <Can permission="delete_user">
            <AntIcon.StopOutlined
              className="action-icon"
              style={{
                fontSize: "15px",
              }}
            />
          </Can>
        )}
      </div>
    </S.ActionsSection>
  );
}

export default ActionsSection;
